"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = exports.PanelSeparator = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const PanelSeparator = () => (react_1.default.createElement("div", { style: {
        flex: "0 0 7px",
        alignSelf: "stretch",
        boxShadow: "inset 1px 1px 2px #000a, inset -1px -1px #fff2",
        minWidth: "7x",
        minHeight: "7px",
    } }));
exports.PanelSeparator = PanelSeparator;
exports.Separator = styled_components_1.styled.div `
  background: radial-gradient(#fff4, #fff1);
  margin: ${(props) => props.noSpace
    ? "0"
    : props.extra
        ? props.theme.gutter
        : props.theme.spacing};
  border: none;
  flex: ${({ grow }) => (grow ? 1 : 0)} 0 1px;
  min-width: 1px;
  min-height: 1px;
`;
//# sourceMappingURL=Separator.js.map